const KDays = [
    {id: "0", value: "今日"},    
    {id: "1", value: "1天前"},
    {id: "2", value: "2天前"},
    {id: "3", value: "3天前"},
    {id: "4", value: "4天前"},
  ];  
  
  export default KDays  